import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

type UserRestrictionsProps = {
  isAllowed: boolean;
  messageCode: string;
  title: string;
  partialMessages: Array<PartialMessageProps>;
  ctaText: string;
  ctaUrl: string;
};

const UserRestrictions = ({
  isAllowed = true,
  messageCode = '',
  title = '',
  partialMessages = [],
  ctaText = '',
  ctaUrl = '',
}: Partial<UserRestrictionsProps> = {}) => {
  return {
    isAllowed,
    messageCode,
    title,
    partialMessages: partialMessages.map((p) => p),
    ctaText,
    ctaUrl,
  };
};

// @ts-expect-error
export { UserRestrictions, UserRestrictionsProps };
